import { RouterProvider } from 'react-router-dom';
import { appRouter } from '@/app/router';
import { AppStatusGate } from '@/features/appStatus';

export function App() {
  return (
    <AppStatusGate>
      <RouterProvider router={appRouter} />
    </AppStatusGate>
  );
}
